module.exports = __webpack_public_path__ + "static/media/med_loader.1f5cf520.gif";